export const enterpriseResourceIndustries = [
  {
    title: 'Aerospace',
    value: 'aerospace',
  },
  {
    title: 'Automotive',
    value: 'automotive',
  },
  {
    title: 'Corporate Social Responsibility',
    value: 'corporateSocialResponsibility',
  },
  {
    title: 'Energy',
    value: 'energy',
  },
  {
    title: 'Financial Services',
    value: 'financialServices',
  },
  {
    title: 'Healthcare & Lifesciences',
    value: 'healthcareAndLifesciences',
  },
  {
    title: 'Learning & Development',
    value: 'learningDevelopment',
  },
  {
    title: 'Oil & Gas',
    value: 'oilGas',
  },
  {
    title: 'Pharmaceutical',
    value: 'pharmaceutical',
  },
  {
    title: 'Professional Services',
    value: 'professionalServices',
  },
  {
    title: 'Public Sector',
    value: 'publicSector',
  },
  {
    title: 'Technology',
    value: 'technology',
  },
  {
    title: 'Telecom',
    value: 'telecom',
  },
] as const;

export const enterpriseResourceKnowledgeAreas = [
  {
    title: 'Artificial Intelligence',
    value: 'artificialIntelligence',
  },
  {
    title: 'Autonomous Systems',
    value: 'autonomousSystems',
  },
  {
    title: 'Energy',
    value: 'energy',
  },
  {
    title: 'Cloud Computing',
    value: 'cloudComputing',
  },

  {
    title: 'Data Science',
    value: 'dataScience',
  },
  {
    title: 'Digital Transformation',
    value: 'digitalTransformation',
  },
  {
    title: 'Future of Work',
    value: 'futureOfWork',
  },
  {
    title: 'Innovation',
    value: 'innovation',
  },
  {
    title: 'Programming',
    value: 'programming',
  },
  {
    title: 'Robotic Process Automation (RPA)',
    value: 'roboticProcessAutomation',
  },
  {
    title: 'Scholarship',
    value: 'scholarship',
  },
  {
    title: 'Upskilling',
    value: 'upskilling',
  },
] as const;

export const enterpriseResourceContentTypes = [
  {
    title: 'Case Study',
    value: 'caseStudy',
  },
  {
    title: 'eBook',
    value: 'ebook',
  },
  {
    title: 'Infographic',
    value: 'infographic',
  },
  {
    title: 'Report',
    value: 'report',
  },
  {
    title: 'Webinar',
    value: 'webinar',
  },
  {
    title: 'Live Event',
    value: 'live-event',
  },
] as const;

export function getIndustryDisplayText(value: string | null) {
  return enterpriseResourceIndustries.find((industry) => industry.value === value)?.title;
}

export function getKnowledgeAreaDisplayText(value: string | null) {
  return enterpriseResourceKnowledgeAreas.find((knowledgeArea) => knowledgeArea.value === value)?.title;
}

export function getContentTypeDisplayText(value: string | null) {
  return enterpriseResourceContentTypes.find((contentType) => contentType.value === value)?.title;
}
